import axios from '@utils/axios';

const viewGeneCombination = {
  state: {
    geneCombinationId: 0,
    phenotype: '',
    phenotypeEn: '',
    gender: { value: 1 },
    description: '',
    descriptionEn: '',
    category: '',
    subCategory: '',
    updatedAt: '',
    updatedBy: null,
    defaultTemplate: '',
    defaultTemplateEn: '',
    combinationGeneCode: [],
    risk: 1
  },
  mutations: {
    setGeneCombinationId(state, id) {
      state.geneCombinationId = id;
    },
    setPhenotype(state, phenotype) {
      state.phenotype = phenotype;
    },
    setPhenotypeEn(state, phenotypeEn) {
      state.phenotypeEn = phenotypeEn;
    },
    setDescription(state, description) {
      state.description = description;
    },
    setDescriptionEn(state, descriptionEn) {
      state.descriptionEn = descriptionEn;
    },
    setCategory(state, category) {
      state.category = category;
    },
    setSubcategory(state, sub) {
      state.subCategory = sub;
    },
    setCombinationGeneCodes(state, codes) {
      state.combinationGeneCode = codes;
    },
    setGender(state, gender) {
      state.gender = gender;
    },
    setUpdatedAt(state, at) {
      state.updatedAt = at;
    },
    setDefaultTemplate(state, template) {
      state.defaultTemplate = template;
    },
    setDefaultTemplateEn(state, templateEn) {
      state.defaultTemplateEn = templateEn;
    },
    setUpdatedBy(state, by) {
      state.updatedBy = by;
    },
    setRisk(state, risk) {
      state.risk = risk;
    }
  },
  actions: {
    fetchGeneCombination(context) {
      return axios.get('admin/genecombinations/getcombination', { params: {
        GeneCombinationId: context.state.geneCombinationId
      } }).then((res) => {
        context.commit('setPhenotype', res.data.result.phenotype);
        context.commit('setPhenotypeEn', res.data.result.phenotypeEn);
        context.commit('setDescription', res.data.result.description);
        context.commit('setDescriptionEn', res.data.result.descriptionEn);
        context.commit('setCategory', res.data.result.category);
        context.commit('setGender', res.data.result.gender);
        context.commit('setSubcategory', res.data.result.subcategory);
        context.commit('setCombinationGeneCodes', res.data.result.combinationGeneCode);
        context.commit('setUpdatedAt', res.data.result.updatedAt);
        context.commit('setDefaultTemplate', res.data.result.defaultTemplate);
        context.commit('setDefaultTemplateEn', res.data.result.defaultTemplateEn);
        context.commit('setUpdatedBy', res.data.result.updatedBy);
        context.commit('setRisk', res.data.result.defaultTemplateRisk);
      });
    },
  },
  namespaced: true
};

export default viewGeneCombination;
